import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/css/reset.css'

// 混入
import _mixin from '@/mixins/index.js'
Vue.mixin(_mixin)

// axios
import { api, apiGet, apiPost, apiUpload } from '@/utils/request'
Vue.prototype.$api = apiGet
Vue.prototype.$apiPost = apiPost
Vue.prototype.$apiUpload = apiUpload

// 各种工具
import { cloneDeep, isPhone, isEmail, isArray, isObj } from '@/utils/index'
Vue.prototype.$cloneDeep = cloneDeep
Vue.prototype.$isPhone = isPhone
Vue.prototype.$isEmail = isEmail
Vue.prototype.$isArray = isArray
Vue.prototype.$isObj = isObj

// 可终止的forEach，return false 即可终止
Array.prototype.forEachBreakable = function (callback) {
    for (let i = 0; i < this.length; i++) {
        if (callback(this[i], i, this) === false) {
            break
        }
    }
}

Vue.config.productionTip = false

// 国际化
import zh from './langurage/zh.js' //中文
import en from './langurage/en.js' //英文
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import locale_ui_zh from 'element-ui/lib/locale/lang/zh-CN' //组件中文
import locale_ui_en from 'element-ui/lib/locale/lang/en' //组件英文
const messages = {
    zh: {
        ...zh,
        ...locale_ui_zh,
    },
    en: {
        ...en,
        ...locale_ui_en,
    },
}

let locale = 'zh' // zh、en
const i18n = new VueI18n({
    locale: locale,
    messages,
})

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/element-#d61818/index.css' // 改 element ui 全局颜色
Vue.use(ElementUI, {
    locale_ui_zh,
    locale_ui_en,
    i18n: (k, v) => i18n.t(k, v),
})

// loading封装
import { Loading } from 'element-ui'
import { Message } from 'element-ui'
Vue.prototype.$load = {
    loading: null,
    open: function (type) {
        this.loading = Loading.service({
            fullscreen: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)',
            customClass: 'm_loading_style',
        })
    },
    close: function (ms = 0) {
        if (!this.loading) return false
        function block(ms) {
            const start = Date.now()
            while (Date.now() - start < ms) {
                // 空循环，阻塞线程
            }
        }
        block(ms)
        this.loading.close()
    },
}

// 消息封装
window.alertSucc = function (message) {
    Message.success({
        message: message || '操作成功',
        offset: 300,
        duration: 1500,
    })
}
window.alertErr = function (message) {
    Message.error({
        message: message || '操作失败，请稍后重试',
        offset: 300,
        duration: 1500,
    })
}

// swiper
let Swiper = require('@/assets/js/swiper-bundle.min')
Vue.prototype.$Swiper = Swiper

// 全局组件注册
// 面包屑
import breadcrumb from '@/components/breadcrumb.vue'
Vue.component('breadcrumb', breadcrumb)

// 商品列表
import productList from '@/components/product-list.vue'
Vue.component('productList', productList)

// 比较浮窗
import compareWin from '@/components/compare-win.vue'
Vue.component('compareWin', compareWin)

Vue.component('el-image-viewer', () => import('element-ui/packages/image/src/image-viewer'))

// html转pdf
import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
